import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import { StaffEntity } from '@/entities/staff.entity';

// @TODO Change file name

@Component<WorkingTimeMixin>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class WorkingTimeMixin extends Vue {
  currentStaff!: StaffEntity;

  async checkin() {
    if (this.currentStaff.isCheckedIn) {
      return;
    }
    try {
      await this.$store.dispatch('staff/check', 'in');
      await this.$cheeers.notify({
        text: this.$t('working.actions.checkin.success'),
      });
    } catch (e) {
      let message = this.$t('working.actions.checkin.fail');
      if (
        e.response &&
        e.response.status !== 500 &&
        e.response.data &&
        e.response.data.message
      ) {
        message = e.response.data.message;
      }
      await this.$cheeers.notify({
        text: message,
        type: 'error',
      });
    }
  }
  async checkout() {
    if (this.currentStaff.isCheckedOut) {
      return;
    }
    try {
      await this.$store.dispatch('staff/check', 'out');
      await this.$cheeers.notify({
        text: this.$t('working.actions.checkout.success'),
      });
    } catch (e) {
      let lang = 'working.actions.checkout.fail';
      if (
        e?.response?.data?.message &&
        Array.isArray(e.response.data.message)
      ) {
        lang = `validation.${e.response.data.message[0].errors[0]}`;
      }
      await this.$cheeers.notify({
        lang,
        type: 'error',
      });
    }
  }
  async overwork() {
    if (this.currentStaff.isCheckedOut) {
      return;
    }
    try {
      await this.$store.dispatch('staff/overwork');
    } catch (e) {
      let lang = 'working.actions.overwork.fail';
      if (
        e?.response?.data?.message &&
        Array.isArray(e.response.data.message)
      ) {
        lang = `validation.${e.response.data.message[0].errors[0]}`;
      }
      await this.$cheeers.notify({
        lang,
        type: 'error',
      });
    }
  }
  async pauseWorking() {
    try {
      await this.$store.dispatch('staff/pause');
      await this.$cheeers.notify({
        text: this.$t('working.actions.pause.success'),
      });
    } catch (e) {
      let lang = 'working.actions.pause.fail';
      if (
        e?.response?.data?.message &&
        Array.isArray(e.response.data.message)
      ) {
        lang = `validation.${e.response.data.message[0].errors[0]}`;
      }
      await this.$cheeers.notify({
        lang,
        type: 'error',
      });
    }
  }
  async continueWorking() {
    try {
      await this.$store.dispatch('staff/continue');
      await this.$cheeers.notify({
        text: this.$t('working.actions.continue.success'),
      });
    } catch (e) {
      let lang = 'working.actions.continue.fail';
      if (
        e?.response?.data?.message &&
        Array.isArray(e.response.data.message)
      ) {
        lang = `validation.${e.response.data.message[0].errors[0]}`;
      }
      await this.$cheeers.notify({
        lang,
        type: 'error',
      });
    }
  }
}
